﻿[<RequireQualifiedAccess>]
module PortalLibs.Shared.Option

open System
open FSharpPlus

let emptyStrIfNone<'T when 'T :> obj> (strOpt: Option<'T>) =
  match strOpt with
  | None -> String.Empty
  | Some s -> s.ToString()

let noneIfEmptyStr (str: string) =
  if String.IsNullOrEmpty str then None else Some str

let noneIfEmptyStrTrim (str: string) =
  if isNull str || str.Trim() = "" then
    None
  else
    Some(str.Trim())

let noneIfEmptyStrOpt strOpt = strOpt >>= noneIfEmptyStr

let noneIfEmptyStrOptTrim strOpt = strOpt >>= noneIfEmptyStrTrim


let emptyMapIfNone<'K, 'T when 'K: comparison> (mapOpt: Map<'K, 'T> option) : Map<'K, 'T> =
  match mapOpt with
  | None -> Map.empty
  | Some map -> map

let emptyListIfNone<'T> (result: 'T list option) : 'T list =
  match result with
  | None -> []
  | Some list -> list

let noneIfEmptyList<'T> (result: 'T list) : 'T list option =
  if result.IsEmpty then None else Some result

let toNullableAll opt =
  match opt with
  | None -> null
  | Some value -> value

let ofNullableAll nullable =
  if isNull (box nullable) then None else Some nullable


let fromParseResult parseRes =
  match parseRes with
  | false, _ -> None
  | true, parsed -> Some parsed

let rec unwrapObjIfOption (obj: obj) =
  let unwrapOpt opt =
    match opt with
    | Some value -> value |> unwrapObjIfOption
    | None -> null

  match obj with
  | :? Option<string> as opt -> unwrapOpt opt
  | :? Option<int> as opt -> unwrapOpt opt
  | :? Option<int8> as opt -> unwrapOpt opt
  | :? Option<int16> as opt -> unwrapOpt opt
  | :? Option<int64> as opt -> unwrapOpt opt
  | :? Option<double> as opt -> unwrapOpt opt
  | :? Option<decimal> as opt -> unwrapOpt opt
  | :? Option<DateTime> as opt -> unwrapOpt opt
  | :? Option<bool> as opt -> unwrapOpt opt
  | :? Option<byte> as opt -> opt |>> string |> unwrapOpt
  | :? Option<byte * int> as opt -> opt |>> (fun (byte, right) -> string byte, right) |> unwrapOpt
  | :? Option<byte * string> as opt -> opt |>> (fun (byte, right) -> string byte, right) |> unwrapOpt
  | :? Option<string * string> as opt -> unwrapOpt opt
  | :? Option<Option<byte> * Option<string>> as opt ->
    opt
    >>= (fun (byteOpt, strOpt) -> (byteOpt, strOpt) ||> lift2 (fun byte str -> string byte, str))
    |> unwrapOpt
  | :? Option<obj> as opt -> unwrapOpt opt
  | _ -> obj

let combine f new' old =
  match new', old with
  | None, None -> None
  | Some new', Some old -> Some(f new' old)
  | None, Some old -> Some old
  | Some new', None -> Some new'

let tryAllElementsHaveValue collection =
  if Seq.exists Option.isNone collection then
    None
  else
    Some(Seq.choose id collection)